module.exports = __webpack_public_path__ + "static/media/process_blue.bda09b42.svg";